import { CheckboxWithLabel } from '@global-engineering-shared/gweb-material-ui';
import React, { ChangeEvent } from 'react';

import useStyles from 'components/CheckboxToggle/CheckboxToggle.styles';
import { Toggle } from 'components/CheckboxToggle/types/Toggle';
import { handleToggleChange } from 'components/CheckboxToggle/utils/handleToggleChange';
import StatusIndicator from 'components/StatusIndicator';

type ToggleProps = {
  toggle: Toggle;
  setToggles: React.Dispatch<React.SetStateAction<Toggle[]>>;
};

const CheckboxToggle = ({ toggle, setToggles }: ToggleProps) => {
  const classes = useStyles({ color: toggle.color });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setToggles((prevToggles) => handleToggleChange(event, prevToggles));
  };

  return (
    <div className={classes.root}>
      <CheckboxWithLabel
        checked={toggle.active}
        LabelProps={{ className: classes.label, label: toggle.value }}
        name={toggle.filter}
        onChange={handleChange}
      />
      <StatusIndicator color={toggle.color} />
    </div>
  );
};

export default CheckboxToggle;
